import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 30000,
});

// keep temp token for the 2FA challenge in-memory + sessionStorage
export const TempToken = {
  set(t) {
    try {
      sessionStorage.setItem("imsyaf_temp", t);
    } catch (_) {}
  },
  get() {
    try {
      return sessionStorage.getItem("imsyaf_temp") || "";
    } catch (_) {
      return "";
    }
  },
  clear() {
    try {
      sessionStorage.removeItem("imsyaf_temp");
    } catch (_) {}
  },
};

api.interceptors.request.use((config) => {
  // For 2FA-related endpoints attach X-Temp-Token if present
  const path = (config.url || "").split("?")[0];
  if (path.includes("/auth/2fa/")) {
    const t = TempToken.get();
    if (t) config.headers["X-Temp-Token"] = t;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
